import { observable, runInAction, toJS } from 'mobx'
import Api from '@api/setMealManage'
import cloneDeep from 'lodash/cloneDeep'
import { DEFAULT_SEARCH_LIST } from './constant'
import { message } from 'hljd'

export default class {
  constructor(centerStore) {
    this.centerStore = centerStore
  }

  @observable tag_list = []
  @observable detail_data = this.centerStore.detailData

  form
  flag = false

  afterGetDetail = detail => {
    this.detail_data = detail
    this.initTagList(detail.tags) // 此时tag_list可能还未获取到，在获取tag_list的地方再执行一次
  }

  // 修改案例属性状态
  changeTagValue = (i, j, flag) => {
    let tempList = cloneDeep(toJS(this.tag_list))
    // 已active的tag数量
    const activeList = tempList[i].children.filter(item => item.isActive)
    if (tempList[i].quantity_range) {
      if (flag) {
        if (activeList.length + 1 <= +tempList[i].quantity_range[1]) {
          tempList[i].children[j].isActive = true
          this.form.setFields({
            [`tags${i}`]: {
              value: activeList,
              errors: []
            }
          })
        }
      } else {
        if (activeList.length - 1 >= +tempList[i].quantity_range[0]) {
          tempList[i].children[j].isActive = false
        } else {
          tempList[i].children[j].isActive = false
          this.form.setFields({
            [`tags${i}`]: {
              value: activeList,
              errors: [new Error('请选择正确数量的标签')]
            }
          })
        }
      }
    } else {
      tempList[i].children[j].isActive = flag
    }
    runInAction(() => {
      this.tag_list = tempList
    })
  }

  formatStepThree = () => {
    if (!this.form) {
      return {}
    }
    const tag_list = []
    const list = this.tag_list || []
    for (let i = 0; i < list.length; i++) {
      for (let j = 0; j < list[i].children?.length; j++) {
        if (list[i].children[j].isActive) {
          tag_list.push(list[i].children[j].mark_id)
        }
      }
    }
    return { ...this.form.getFieldsValue(), tag_list: tag_list.join(',') }
  }

  /** 校验数据 */
  validateStepThree = () => {
    let flag = true

    const { property_id, weddingPhotoType, isSingle } = this.centerStore

    // 过滤掉婚纱摄影旅拍标签
    const filterTagList = this.tag_list.filter(item => {
      return (
        !(
          property_id == 6 &&
          weddingPhotoType == 4 &&
          (item.id == 3377 || item.id == 3421)
        ) && !(property_id == 12 && isSingle != 1 && item.id == 3902)
      )
    })

    filterTagList.forEach((item, index) => {
      const list = item.children.filter(val => val.isActive)
      const limit = item.quantity_range ? item.quantity_range : []
      if (list.length > +limit[1] || list.length < +limit[0]) {
        this.form.setFields({
          [`tags${index}`]: {
            value: '',
            errors: [new Error('请选择正确数量的标签')]
          }
        })
        flag = false
      }
    })

    this.form.validateFieldsAndScroll(
      ['abbreviation', 'marketing_info'],
      (err, values) => {
        if (err) {
          flag = false
        }
      }
    )

    if (!flag) {
      message.warn('推荐信息未选择正确数量的标签')
    }

    return flag
  }

  /**
   * 保存数据
   * @param {string} type draft-草稿  save-发布
   */
  saveData = type => {
    let data = {}
    this.flag = true

    const { property_id, weddingPhotoType, isSingle } = this.centerStore

    // 过滤掉婚纱摄影旅拍标签
    const filterTagList = this.tag_list.filter(item => {
      return (
        !(
          property_id == 6 &&
          weddingPhotoType == 4 &&
          (item.id == 3377 || item.id == 3421)
        ) && !(property_id == 12 && isSingle != 1 && item.id == 3902)
      )
    })

    filterTagList.forEach((item, index) => {
      const list = item.children.filter(val => val.isActive)
      const limit = item.quantity_range ? item.quantity_range : []
      if (
        type === 'save' &&
        (list.length > +limit[1] || list.length < +limit[0])
      ) {
        this.form.setFields({
          [`tags${index}`]: {
            value: '',
            errors: [new Error('请选择正确数量的标签')]
          }
        })
        this.flag = false
      }
    })

    if (type === 'draft') {
      // 存为草稿
      data = { ...this.form.getFieldsValue() }
      return {
        tag_list: this.tag_list,
        ...data
      }
    } else {
      this.form.validateFieldsAndScroll(
        ['abbreviation', 'marketing_info'],
        (err, values) => {
          if (err) {
            this.flag = false
          } else {
            data = {
              ...values
            }
          }
        }
      )
      if (this.flag) {
        return {
          tag_list: this.tag_list,
          ...data
        }
      } else {
        message.warn('推荐信息未选择正确数量的标签')
        return ''
      }
    }
  }

  //获取tag初始状态
  initTagList = tagIds => {
    if (!tagIds || tagIds.length == 0) {
      return
    }
    const tags = tagIds.map(item => item.mark_id)
    const tempTags = [...toJS(this.tag_list)]
    if (tempTags.some(chlid => chlid.children.some(item => item.isActive))) {
      return
    }

    for (let i = 0; i < tempTags.length; i++) {
      for (let j = 0; j < tempTags[i].children.length; j++) {
        if (tags.includes(tempTags[i].children[j].mark_id)) {
          tempTags[i].children[j].isActive = true
        }
      }
    }
    this.tag_list = [...tempTags]
  }

  getForm = form => {
    this.form = form
  }

  //获取商家简称、商家名分词信息
  @observable add_reviation = []
  @observable abbreviation = ''
  getMerchantAbbreviation = async () => {
    const { success, data } = await Api.getMerchantAbbreviation()
    if (success) {
      runInAction(() => {
        this.abbreviation = data.abbreviation
        this.add_reviation = data.recommendAbbreviation
      })
    }
  }

  //获取商家推荐搜索信息
  @observable market_info = DEFAULT_SEARCH_LIST
  getMarketingInfoRecommend = async keyword => {
    if (!keyword) {
      runInAction(() => {
        this.market_info = DEFAULT_SEARCH_LIST
      })
      return
    }
    const { success, data } = await Api.getMarketingInfoRecommend({
      keyword
    })
    if (success) {
      runInAction(() => {
        this.market_info = data
      })
    }
  }
}
